export default "__VITE_ASSET__DiKTjIOA__"